export default __webpack_public_path__ + "static/media/icons_policies.675daf91.svg";